import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

export interface MessageDialogData {
  text: string;
}

@Component({
  selector: 'ui-message-dialog',
  imports: [MatDialogModule],
  template: `
    <div class="p-8 text-center">
      <p class="m-0 text-cp-primary-100">{{ data.text }}</p>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageDialogComponent {
  protected readonly data = inject<MessageDialogData>(MAT_DIALOG_DATA);
}
